import React, {useState} from "react";

interface CheckoutState {
  checkoutCompleted: boolean;
  setCheckoutCompleted: (value: boolean) => void;
}

const initialState: CheckoutState = {
  checkoutCompleted: false,
  setCheckoutCompleted: () => {},
};

export const CheckoutContext = React.createContext<CheckoutState>(initialState);

export const CheckoutProvider = ({children}: {children: React.ReactNode}) => {
  const [checkoutCompleted, setCheckoutCompleted] = useState(false);
  return (
    <CheckoutContext.Provider
      value={{
        checkoutCompleted,
        setCheckoutCompleted,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};
